import Template from "backbone/projects/templates/add_skills.js.hamlc"

export default class AddSkillsView extends Backbone.View
  initialize: (options) ->
    @project = options.project
    @getFormData = options.getFormData
    @skills = options.skills

  render: ->
    @$el.html(Template(project: @project, skills: @skills))
    @$form = @$el.find("form")

  submitAndFinishLater: ->
    if @$form.exists() && @$form.parsley().isValid()
      @maskAndSave()
    else
      @project.set(savePending: false)

  submitAddSkillsForm: ->
    if @$form.exists() && @$form.parsley().validate()
      @maskAndSave()

  maskAndSave: ->
    @$form.maskLoading()
    formdata = @getFormData(@$form)
    @project.set(savePending: true)
    @project.save(formdata, {
      wait: true
      success: (model, response, options) =>
        @project.set(addSkillsSucceeded: true, savePending: false, skills: response.skills)
      error: =>
        @project.set(addSkillsSucceeded: false, savePending: false)
    }).always =>
      @$form.unmaskLoading()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/add_skills_view.js.coffee